export var PRESS_EVENT_TIMER_NAME = 'pressEvent';
export var MOUSE_EMULATION_GUARD_TIMER_NAME = 'mouseEmulation';
export var SET_ACTIVATION_TIMER_NAME = 'setHovering';
export var UNSET_ACTIVATION_TIMER_NAME = 'unsetHovering';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-cursor-position/dist/es/constants.js
// module id = 132
// module chunks = 0